module.exports = __webpack_public_path__ + "img/pricing-icon.8348c907.svg";